import {Image} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {tag2url} from '@yandex-delivery/utils'
import React, {memo} from 'react'

import type {IconWidgetProps as Props} from '../types'

const image = css`
  margin-inline-end: ${spacing(1.5)};
  margin-inline-start: ${spacing(0.5)};
`

export const IconWidget = memo(
  ({
    config: {
      icon: {image_tag},
    },
  }: Props): React.ReactElement => <Image alt="" className={image} height={32} src={tag2url(image_tag)} />,
)
